/* eslint-disable no-nested-ternary */
import AnnualReturnColumn from "components/financials/modern/selection/AnnualReturnColumn";
import ChangeText from "components/financials/modern/selection/ChangeText";
import VariationColumn from "components/financials/modern/selection/VariationColumn";
import derivedValuesFromSelection from "components/financials/modern/selection/derivedValuesFromSelection";
import type { IndicatorSelection, SheetIndicator } from "components/financials/modern/types";
import classNames from "components/ui/classNames";
import useTheme from "components/ui/useTheme";
import { useIntl } from "react-intl";
import tinycolor from "tinycolor2";
import type { IIndicatorKind } from "types/graphqlTypes";

interface SelectionFinancialRangeValuesProps {
  indicator: SheetIndicator;
  selection: IndicatorSelection[];
}
export default function SelectionFinancialRangeValues({ indicator, selection }: SelectionFinancialRangeValuesProps) {
  const intl = useIntl();

  const valueFormatter = new Intl.NumberFormat(intl.locale, {
    notation: "standard",
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 6,
    maximumFractionDigits: 2,
  });

  const theme = useTheme();
  const isDarkTheme = theme === "dark";
  const textColor = isDarkTheme
    ? tinycolor(indicator.columnTheme.textColor).brighten(60).toRgbString()
    : indicator.columnTheme.textColor;

  const derivedSelectionValues = derivedValuesFromSelection(selection);
  if (!derivedSelectionValues) {
    return null;
  }

  const { firstValue, variation, displayValue, annualReturn, valuesAreTheSame } = derivedSelectionValues;

  return (
    <div className="flex space-x-6">
      <div className="flex flex-col">
        <h1
          className={classNames("text-xl font-bold", {
            "text-red-600 dark:text-red-400": displayValue < 0,
          })}
          style={{
            color: displayValue >= 0 ? textColor : undefined,
          }}
        >
          {valueFormatter.format(valuesAreTheSame ? firstValue : displayValue)}
        </h1>

        <ChangeText kind={indicator.kind as IIndicatorKind} variation={variation} />
      </div>

      <VariationColumn variation={variation} />

      <AnnualReturnColumn annualReturn={annualReturn} />
    </div>
  );
}
